// Склонение слова "день" по числу (русский язык)
export function pluralizeDays(n) {
	n = Math.abs(n) % 100;
	const n1 = n % 10;
	if (n > 10 && n < 20) return 'дней';
	if (n1 > 1 && n1 < 5) return 'дня';
	if (n1 === 1) return 'день';
	return 'дней';
} 